import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from 'src/app/utils/app-settings';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AttemptService {

  constructor(private http: HttpClient) { }

  attemptTest(testId: number): Observable<any> {
    return this.http.post<any>(`${AppSettings.apiUrl}attempt`, { "exam_test_id": testId });
  }

  completeAttempt(attemptId: number) {
    return this.http.patch(`${AppSettings.apiUrl}attempt/${attemptId}`, { "status": 2 });
  }
}
